module.exports = __webpack_public_path__ + "img/242-2099df.png";